import { styled, css } from "styled-components";

export const PressContainerBodyLabel = css`
  font-family: var(--font-pt-serif);
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.56rem;
`;

export const CommonStyle = css`
  display: flex;
  flex: 1 0 0;
  padding: var(--Spacing-8, 0.8rem) var(--Spacing-4, 0.4rem);
  align-items: flex-start;
  gap: var(--Spacing-2, 0.2rem);
  border-right: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
`;

export const NewInfoPressTableBody = styled.div<{
  hovered: boolean;
  checked: boolean;
}>`
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  border-top: none;
  border-right: none;
  background-color: ${({ hovered, checked }) => {
    if (checked) return "#CBD0D8";
    if (hovered) return "#E0F4FF";
    return "var(--Color-Common-Bg-Interactive-Secondary, #fff)";
  }};
  ${({ checked }) =>
    checked &&
    css`
      & * {
        color: #7c899c !important;
      }
    `}
`;

export const NewInfoPressTablePressIdWrapper = styled.div`
  max-width: 14.4rem;
  align-items: flex-start;
  justify-content: space-between;
  ${CommonStyle}
  cursor: pointer;
`;

export const NewInfoPressId = styled.button`
  all: unset;
  ${PressContainerBodyLabel}
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  padding: var(--Spacing-2, 0.2rem) 0 var(--Spacing-2, 0.2rem)
    var(--Spacing-6, 0.6rem);
  align-items: center;
`;

export const NewInfoPressIcon = styled.button`
  all: unset;
`;
export const NewInfoPressTablePressTitleData = styled.div`
  ${CommonStyle}
`;

export const NewInfoPressTablePressTitleOverflow = styled.div`
  ${PressContainerBodyLabel}
  padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
`;
export const NewInfoPressTableReviewRequiredData = styled.div`
  max-width: 12.8rem;
  ${CommonStyle}
  padding: var(--Spacing-8, 0.8rem) var(--Spacing-4, 0.4rem) var(--Spacing-8, 0.8rem) 0;

  div {
    width: 12.8rem;
    text-align: center;
    div {
      ${PressContainerBodyLabel}
      padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
    }
  }
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
